import React, { FC } from 'react'
import Footer from './footer'
import { MessageProps } from 'message/index.props'

export interface WrapProps {
  message: MessageProps
}

const Wrap: FC<WrapProps> = ({ children, message }) => {
  return (
    <>
      <section>{children}</section>
      <Footer message={message} />
    </>
  )
}

export default Wrap
